export const logDeprecationWarning = (message: string) => {
  // eslint-disable-next-line no-console
  console.warn(`⚠️ [uploadthing][deprecated] ${message}`);
};
